module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "img6.8340b518.jpg" + "?" + Date.now();